import navigation from '../navigation/rbmc.navigation';

const header = {
    $header:                    undefined,
    $headerInner:               undefined,
    $mainNavList:               undefined,
    $mainNavGroup:              undefined,
    $mobileNavButton:           undefined,
    $subShopSelector:           undefined,
    HEADER_HEIGHT:              undefined,
    TRANSPARENT_CLASS:          'transparent',
    STYLE_ADAPT_CLASS:          'page-header__inner--adapted',
    STYLE_ADAPT_HOVER_CLASS:    'page-header__inner--hover',
    REACT_CLASS_MAIN_NAV_INNER: '.NavigationComponent__innerWrapper',
    REACT_CLASS_MAIN_NAV_GROUP: '.NavigationComponent__mainNavGroup',
    REACT_CLASS_MOBILE_BUTTON:  '.CMSMobileCategoryNavigationComponent',
    REACT_SUB_SHOP_BUTTON:      '.CMSSubshopNavigationSelectorComponent',
    LAST_SCROLL:                560,
    SCROLL_DELTA:               50,
    SCROLL_TOP_THRESHOLD:       560,
    HEADER_MAIN_COLOR:          undefined,
    SUBSHOP_ACTIVE:             false,
    CORRECTION_FACTOR:          60,
    mutationObserver:           undefined,

    /**
     * Method used for caching selectors for later use
     */
    headerScrollControlInit: () => {
        header.$body                     = $('body');
        header.$header                   = $('.page-header');
        header.$headerInner              = header.$header.find('.page-header__inner');
        header.$headerNotification       = header.$header.find('.page-header__notification');
        header.$mainNavList              = header.$headerInner.find(header.REACT_CLASS_MAIN_NAV_INNER);
        header.$mobileNavButton          = header.$headerInner.find(header.REACT_CLASS_MOBILE_BUTTON);
        header.$subShopSelector          = header.$headerInner.find(header.REACT_SUB_SHOP_BUTTON);
        header.HEADER_MAIN_COLOR         = getComputedStyle(document.documentElement).getPropertyValue('--headerColor').trim().toLowerCase();
        header.HEADER_SCCROLL_MAIN_COLOR = getComputedStyle(document.documentElement).getPropertyValue('--scrollHeaderColor').trim().toLowerCase();
        header.HEADER_HEIGHT             = header.$header.outerHeight();
    },

    isShopByTeamEvent: () => {
        return window.location.hash.includes('shop-by-team-event');
    },

    /**
     * Has logic for scroll behavior, both visibility and styling changes are triggered in this method
     * @param evt
     */
    scrollControl: (evt) => {
        const $this = $(evt.currentTarget), nowScrollTop = $this.scrollTop();
        if (Math.abs(header.LAST_SCROLL - nowScrollTop) >= header.SCROLL_DELTA) {
            if (nowScrollTop > header.LAST_SCROLL) {
                header.HEADER_HEIGHT = header.$header.outerHeight();
                // ACTION ON SCROLLING DOWN
                // RBMC-5093: don't hide header if menu is open
                if (!header.$headerInner.hasClass(header.STYLE_ADAPT_HOVER_CLASS)) {
                    header.$headerInner.css({top: -header.HEADER_HEIGHT - header.CORRECTION_FACTOR});
                }
            } else {
                // ACTION ON SCROLLING UP
                header.$headerInner.css({top: 0});
            }
            header.LAST_SCROLL = nowScrollTop < 0 ? 0 : nowScrollTop;
        }

        if ($this.scrollTop() > header.SCROLL_TOP_THRESHOLD) {
            header.headerBarStyleSwitcher(false);
        } else {
            header.headerBarStyleSwitcher(true);
        }

        setTimeout(() => {
            header.applyHeaderPill(header.isTransparent());
        }, 500);
    },

    resizeControl() {
        const style = !header.isTransparent() ? {
            paddingTop: header.$header.outerHeight()
        } : {
            paddingTop: header.$headerNotification.outerHeight()
        }
        header.$body.css(style);
    },

    applyHeaderPill(isTransparent) {
        isTransparent ? header.$headerInner.addClass(header.TRANSPARENT_CLASS) : header.$headerInner.removeClass(header.TRANSPARENT_CLASS);
    },

    onMutate(mutationList, observer) {
        mutationList.forEach((mutation) => {
            switch (mutation.type) {
                case 'childList':
                    header.resizeControl();
                    break;
            }
        });
    },

    /**
     * Just an event binder, enrich this method if more event has to be added
     * @returns {*|jQuery}
     */
    bindEvent: () => {
        header.mutationObserver = new MutationObserver(header.onMutate);
        const observerOptions   = {
            childList:  true,
            attributes: false,
            // Omit (or set to false) to observe only changes to the parent node
            subtree: true
        };
        header.mutationObserver.observe(header.$header[0], observerOptions);

        if (header.$header.length && header.$headerInner.length) {

            const $window = $(window);
            $window.on('scroll', header.scrollControl).trigger('scroll');
            $window.on('resize', header.resizeControl).trigger('resize');

            const changeHeaderLook = (e) => {
                if (e.type === "click") {
                    header.SUBSHOP_ACTIVE = true;
                    header.applyHeaderPill(false);
                }
                header.calculateHeaderForCssVariable();
                if (e.currentTarget.children && (e.currentTarget.children.length > 1)) {
                    navigation.setGreyout(true);
                    header.showHeaderHover();
                } else {
                    //in case we enter an empty node from a non-empty one
                    navigation.setGreyout(false);
                    setTimeout(() => {
                        if (!header.isShopByTeamEvent()) {
                            header.showHeaderHover(false);
                        }
                    }, 0);
                }
            };

            const restoreHeaderLookEmptyNode = (e) => {
                if (e.type === "click") {
                    header.SUBSHOP_ACTIVE = false;
                    header.applyHeaderPill(header.isTransparent());
                }

                if (e.currentTarget.children && (e.currentTarget.children.length < 2)) {
                    navigation.setGreyout(false);
                    setTimeout(() => {
                        if (!header.isShopByTeamEvent()) {
                            header.showHeaderHover(false);
                        }
                    }, 0);
                }
            };

            const restoreHeaderLook = (e) => {
                if (e.type === "click") {
                    header.SUBSHOP_ACTIVE = false;
                    header.applyHeaderPill(header.isTransparent());
                }

                navigation.setGreyout(false);

                setTimeout(() => {
                    if (!header.isShopByTeamEvent()) {
                        header.showHeaderHover(false);
                    }
                }, 0);
            };

            if (header.isShopByTeamEvent()) {
                // Needed just for the first access
                header.showHeaderHover();
                setTimeout(() => {
                    header.applyHeaderPill(false);
                }, 500);
            }

            header.$headerInner.on('mouseenter', header.REACT_CLASS_MAIN_NAV_GROUP, changeHeaderLook);
            //only unblur background if it is was not blurred by a non-empty node before because
            // the flyout nav is still visible at this point
            header.$headerInner.on('mouseleave', header.REACT_CLASS_MAIN_NAV_GROUP, restoreHeaderLookEmptyNode);
            header.$headerInner.on('mouseleave', header.REACT_CLASS_MAIN_NAV_INNER, restoreHeaderLook);
            header.$subShopSelector.on('click', '.MenuButton__openIcon', changeHeaderLook);
            header.$subShopSelector.on('click', '.MenuButton__closeIcon', restoreHeaderLook);
            header.$mobileNavButton.on('click', '.MenuButton__openIcon', changeHeaderLook);
            header.$mobileNavButton.on('click', '.MenuButton__closeIcon', restoreHeaderLook);
            // try to handle some async hell with Archibald
            setTimeout(function () {
                header.calculateHeaderForCssVariable();
            }, 500);
        }
    },

    calculateHeaderForCssVariable() {
        // For archibald
        document.documentElement.style.setProperty('--headerHeight', `${!header.isTransparent() ? header.$header.outerHeight() : 0}px`);
        document.documentElement.style.setProperty('--headerHeightForFixedNav', `${header.$header.outerHeight()}px`);
        document.documentElement.style.setProperty('--headerHeightForAbsoluteNav', `${header.$headerInner.outerHeight()}px`);
    },

    /**
     * It will add class that will change header colors if scrolled over SCROLL_TOP_THRESHOLD
     * @param standard
     * @returns {*}
     */
    headerBarStyleSwitcher: (standard = true) => {
        standard ? header.$headerInner.removeClass(header.STYLE_ADAPT_CLASS)
                : header.$headerInner.addClass(header.STYLE_ADAPT_CLASS);

    },

    showHeaderHover(show = true) {
        show || header.SUBSHOP_ACTIVE ? header.$headerInner.addClass(header.STYLE_ADAPT_HOVER_CLASS) : header.$headerInner.removeClass(
                header.STYLE_ADAPT_HOVER_CLASS);
    },

    isTransparent: () => (header.HEADER_MAIN_COLOR === header.TRANSPARENT_CLASS && window.pageYOffset < header.SCROLL_TOP_THRESHOLD)
            || (header.HEADER_SCCROLL_MAIN_COLOR === header.TRANSPARENT_CLASS && window.pageYOffset > header.SCROLL_TOP_THRESHOLD)
}

$(() => {
    if ($('.page-header__inner').length) {
        header.headerScrollControlInit();
        header.bindEvent();
    }
});

export default header;
